export const defaultFilters = [{ id: 0, name: 'Show All' }];
